// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\auth\\\\AuthStatus.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\auth\\AuthStatus.tsx");
  import.meta.hot.lastModified = "1759744975079.7283";
}
// REMIX HMR END

import React from 'react';
import { useNavigate } from '@remix-run/react';
import { handleLogout, getUserData, isAuthenticated } from '~/lib/api';
export const AuthStatus = ({
  className = ""
}) => {
  _s();
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  React.useEffect(() => {
    const checkAuthStatus = () => {
      const authenticated = isAuthenticated();
      setIsLoggedIn(authenticated);
      if (authenticated) {
        const userData = getUserData();
        setUser(userData);
      }
    };
    checkAuthStatus();

    // Check auth status periodically
    const interval = setInterval(checkAuthStatus, 5000);
    return () => clearInterval(interval);
  }, []);
  const handleLogoutClick = async () => {
    try {
      await handleLogout();
      setIsLoggedIn(false);
      setUser(null);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
  if (!isLoggedIn) {
    return <div className={`flex gap-2 ${className}`}>
        <button onClick={() => navigate('/login')} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">
          Login
        </button>
        <button onClick={() => navigate('/signup')} className="px-4 py-2 text-sm bg-orange-400 text-white rounded-md hover:bg-orange-500">
          Sign Up
        </button>
      </div>;
  }
  return <div className={`flex items-center gap-3 ${className}`}>
      {user && <span className="text-sm text-gray-600">
          Welcome, {user.fname}!
        </span>}
      <button onClick={handleLogoutClick} className="px-4 py-2 text-sm text-red-600 hover:text-red-800">
        Logout
      </button>
    </div>;
};
_s(AuthStatus, "+KXJLcnnK+yF1iGLxELrcBH1iS0=", false, function () {
  return [useNavigate];
});
_c = AuthStatus;
export const ProtectedRoute = ({
  children,
  fallback
}) => {
  _s2();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = React.useState(null);
  React.useEffect(() => {
    const authenticated = isAuthenticated();
    setIsLoggedIn(authenticated);
    if (!authenticated) {
      navigate('/login');
    }
  }, [navigate]);
  if (isLoggedIn === null) {
    return <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
      </div>;
  }
  if (!isLoggedIn) {
    return fallback || null;
  }
  return <>{children}</>;
};
_s2(ProtectedRoute, "jrr/u2Vz6WayCT5/HyGRTc+KSe8=", false, function () {
  return [useNavigate];
});
_c2 = ProtectedRoute;
var _c, _c2;
$RefreshReg$(_c, "AuthStatus");
$RefreshReg$(_c2, "ProtectedRoute");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;